<template>
  <!-- <div id="nav">
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link> |
    <router-link to="/orders">Orders</router-link>
  </div> -->
  <router-view />
</template>

<script></script>

<style lang="scss">
@import "./assets/scss/global.scss";
</style>
